import Component from '../abstracts/Component';

export default class StoreLocatorDetailComponent extends Component {

  get SELECTORS() {
    return {
      mapContainer: '#map-container',
      slider: '[data-js-slider]',
    }
  }

  constructor(htmlEl) {
    super();

    this.mapContainer = htmlEl.querySelector(this.SELECTORS.mapContainer);

    this.lat = Number(htmlEl.dataset.lat);
    this.lng = Number(htmlEl.dataset.lng);
    this.displayName = htmlEl.dataset.name;

    this.googleApiKey;
    this.googleLanguage;
    this.map;
    this.marker;
    // this.isViewMobile = this.isMobile();
    this.slider = document.querySelector(this.SELECTORS.slider);

  }

  /**
   * Function to create a marker on the map for the store
   */
  createMarker() {
    // Create svg for pin. Images are handled via scss
    const pinImg = document.createElement("img");
    pinImg.id = this.displayName;
    pinImg.className = 'marella-marker';

    // Create marker
    const marker = new this.AdvancedMarkerElement({
      map: this.map,
      position: { lat: this.lat, lng: this.lng },
      title: this.displayName,
      content: pinImg
    });
    this.marker = marker;
  }

  /**
   * Function to load and register external libraries
   * @returns {Promise} - a promise in order to use callback fns
   */
  async loadLibraries() {
    return new Promise((resolve, reject) => {
      // get data
      this.googleApiKey = $("#googleApiKey").val();
      this.googleLanguage = $("#googleLanguage").val();
      const apiUrl = `https://maps.googleapis.com/maps/api/js?v=quarterly&key=${this.googleApiKey}&libraries=places,geometry&language=${this.googleLanguage}`;

      // load google maps script
      this.moduleLoader.loadExternalScript(apiUrl).then(async () => {
        // load google maps libraries
        const { Map } = await google.maps.importLibrary('maps');
        this.Map = Map;
        const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
        this.AdvancedMarkerElement = AdvancedMarkerElement;
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }

  /**
   * Function to init map with styles and options. It discriminates if we are in mobile or desktop view
   */
  initMap() {
    // map styles
    /*const _styles = [
      { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#000000' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#c9c9c9' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{ color: '#fcf6e7' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
    ];*/

    // map options
    const options = {
      zoom: 16,
      center: { lat: this.lat, lng: this.lng },
      // styles: _styles, // useless  cause the style is in the ID
      disableDefaultUI: true,
      scaleControl: false,
      fullscreenControl: false,
      zoomControl: false,
      gestureHandling: 'cooperative',
      mapId: 'DEMO_MAP_ID',
    };

    // Create map
    this.map = new this.Map(this.mapContainer, options);
  }

  render() {
    super.render();

    // Load libraries
    this.loadLibraries().then(() => {
      // Init map
      this.initMap();
      // Load stores
      this.createMarker();
    });
  }
}
